import { render, staticRenderFns } from "./SupplierSizes.vue?vue&type=template&id=6044d545"
import script from "./SupplierSizes.ts?vue&type=script&lang=ts&external"
export * from "./SupplierSizes.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports